import { SUPPORT_PHONE } from "../../lib/constants";

export default function PhoneComponent() {
  return (
    <a 
      href={`tel:${SUPPORT_PHONE}`}
      style={{
        fontWeight: '500',
        color: '#2563eb',
        textDecoration: 'underline'
      }}
      onMouseEnter={(e) => e.currentTarget.style.color = '#1d4ed8'}
      onMouseLeave={(e) => e.currentTarget.style.color = '#2563eb'}
    >
      {SUPPORT_PHONE}
    </a>
  );
}